











































































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import axios from 'axios';
import { AttachmentRequest, Accessible, attachmentApis, AttachmentSignedUrlResponse } from '@/api/attachments.api';
import AttachmentCopyShardDialog from './AttachmentCopyShardDialog.vue';

@Component({ components: { AttachmentCopyShardDialog } })
export default class NewAttachmentDialog extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Ref('copyAttachmentShard') copyAttachmentShard!: AttachmentCopyShardDialog;

  Accessible = Accessible;
  selectedMode: Accessible | null = null;
  fileList: any[] = [];
  selectedFile: File | null = null;
  uploading = false;
  uploadProgress = 0;
  DEFAULT_EXPIRE_DAYS = 30;

  mounted() {
    // 重置状态
    this.resetMode();
  }

  get dialogVisible(): boolean {
    return this.visible;
  }

  set dialogVisible(val: boolean) {
    this.$emit('update:visible', val);
  }

  get modeText(): string {
    return this.selectedMode === Accessible.ALL ? '对所有人开放' : '仅限公司员工';
  }

  get modeDescription(): string {
    return this.selectedMode === Accessible.ALL ? '任何人都可以访问此附件' : '仅对收件人并且是公司员工可见';
  }

  selectMode(mode: Accessible): void {
    this.selectedMode = mode;
  }

  resetMode(): void {
    this.selectedMode = null;
    this.fileList = [];
    this.selectedFile = null;
    this.uploading = false;
    this.uploadProgress = 0;
  }

  handleFileChange(file: any, fileList: any[]): void {
    // 文件选择变化时
    this.fileList = fileList;
    this.selectedFile = file.raw;
  }

  handleFileRemove(file: any, fileList: any[]): void {
    // 文件移除时
    this.fileList = fileList;
    this.selectedFile = null;
  }

  async handleConfirm(): Promise<void> {
    if (!this.selectedMode) {
      this.$message.warning('请选择访问权限模式');
      return;
    }
    if (!this.selectedFile) {
      this.$message.warning('请选择要上传的文件');
      return;
    }

    const signedReq: AttachmentRequest = {
      accessible: this.selectedMode,
      expire_in_seconds: this.DEFAULT_EXPIRE_DAYS * 24 * 3600,
      filename: this.selectedFile.name,
      filesize_bytes: this.selectedFile.size,
      content_type: this.selectedFile.type || 'application/octet-stream'
    };

    let response;
    try {
      response = await attachmentApis.requestPutSignedUrl(signedReq);
    } catch (error) {
      this.$message.error(error.message);
      return;
    }

    // 开始上传
    await this.uploadFile(response);
  }

  async uploadFile(signedResp: AttachmentSignedUrlResponse): Promise<void> {
    if (!this.selectedFile) return;

    this.uploading = true;
    this.uploadProgress = 0;

    try {
      const response = await axios.put(signedResp.pre_signed_url, this.selectedFile, {
        headers: signedResp.headers,
        onUploadProgress: (progressEvent: any) => {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      });
      this.uploading = false;
      // 获取响应头
      const etag = response.headers.Etag || response.headers.etag;
      // 回调函数，传递响应数据和响应头
      try {
        await attachmentApis.completePutSignedUrl({ attachment_uid: signedResp.attachment.uid, etag: etag });
      } catch (error) {
        this.$message.error(`文件校验失败: ${error.message}`);
        return;
      }
      this.copyAttachmentShard.show(signedResp.attachment);
      this.$emit('refresh');
      this.resetMode();
      this.dialogVisible = false;
    } catch (error) {
      this.uploading = false;
      this.uploadProgress = 0;
      this.$message.error('文件上传失败: ' + (error.response?.data?.message || error.message));
    }
  }

  handleClose(): void {
    if (this.uploading) {
      this.$confirm('文件正在上传中，确定要取消吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.resetMode();
          this.dialogVisible = false;
        })
        .catch(() => {
          // 用户取消关闭
        });
    } else {
      this.resetMode();
      this.dialogVisible = false;
    }
  }
}
